export default __webpack_public_path__ + "static/media/left-foot-not-selected.29529e36.svg";